export * from "./login.constants";
export * from "./shutterBs.constants";
export * from "./events.constants";
export * from "./payments.constants";
export * from "./configurations.constants";
export * from "./customers.constants";
export * from "./reels.constants";
export * from "./draftEvents.constants";
export * from "./marketing.constants";
export * from "./messageBoard.constants";
export * from "./gallery.constants";
export * from "./reports.constants";

export const globalConstants = {
  REQUEST: "_REQUEST",
  SUCCESS: "_SUCCESS",
  FAILURE: "_FAILURE",
};

export const globalSystemConstants = {
  SPINNER_ACTIVATE: "SPINNER_ACTIVATE",
  SPINNER_DIACTIVATE: "SPINNER_DIACTIVATE",
  OVERLAY_ACTIVATE: "OVERLAY_ACTIVATE",
  OVERLAY_DIACTIVATE: "OVERLAY_DIACTIVATE",
  DOWNLOAD_SPINNER_ACTIVATE: "DOWNLOAD_SPINNER_ACTIVATE",
  DOWNLOAD_SPINNER_DIACTIVATE: "DOWNLOAD_SPINNER_DIACTIVATE",
};

export const paginationConstants = {
  PAGINATION_FILTER_TYPE: {
    ACTIVE: 1,
    ALL: 2,
    CONTAINS: 3,
    SHUTTERB_NEW_APPLICANT_TAB: 4,
    SHUTTERB_ACTIVE_TAB: 5,
    SHUTTERB_ARCHIVE_TAB: 6,
    SHUTTERB_HOLD_TAB: 7,
    DATE_RANGE: 8,
    LIST_DATE_RANGE: 9,
  },
};

export const userType = {
  ADMIN: "1",
};

export const menuUrlConstants = {
  SB_TAB1: "ShutterBs/:tab=1",
  SB_TAB2: "ShutterBs/:tab=2",
  SB_TAB3: "ShutterBs/:tab=3",
  SB_TAB4: "ShutterBs/:tab=4",
  CUSTOMERS_TAB: "Customers",
  EVENTS_TAB: "Events",
  UPCOMING_EVENTS_TAB: "UpcomingEvents",
  COMPLETED_EVENTS_TAB: "CompletedEvents",
  CANCELED_EVENTS_TAB: "CanceledEvents",
  DRAFT_EVENTS_TAB: "DraftEvents",
  REELS_TAB: "Reels",
  PROMO_CODES_TAB: "PromoCodes",
  POSTAL_CODES_TAB: "PostalCodes",
  DEVICES_TAB: "SmartPhoneDevices",
  HOME_PAGE_SBS_TAB: "HomePageShutterbs",
  PAYMENTS_TAB: "Payments",
  TAX_AND_FEE_TAB: "TaxAndFee",
  AFFILIATE_LINKS_TAB: "AffiliateLinks",
  AFFILIATE_REPORTS_TAB: "AffiliateReports",
  PROMO_BALANCE_TAB: "PromoBalance",
  GIFT_CARD_TAB: "GiftCard",
  REEL_TYPES_TAB: "ReelTypes",
  MONITORING_REPORT_TAB: "MonitoringReport",
  RECAP_FEEDBACK_TAB: "RecapFeedback",
  REEL_VIBES_TAB: "ReelVibes",

};

export const sharedConstants = {
  KB_TO_MB_BYTES: 1048576, //1024 * 1024 = 1048576
};


export const timezoneOptions = [
  {
    label: "(UTC-12:00) International Date Line West",
    value: "Etc/GMT+12",
  },
  {
    label: "(UTC-11:00) Coordinated Universal Time-11",
    value: "Etc/GMT+11",
  },
  {
    label: "(UTC-10:00) Aleutian Islands",
    value: "America/Adak",
  },
  {
    label: "(UTC-10:00) Hawaii",
    value: "Pacific/Honolulu",
  },
  {
    label: "(UTC-09:30) Marquesas Islands",
    value: "Pacific/Marquesas",
  },
  {
    label: "(UTC-09:00) Alaska",
    value: "America/Anchorage",
  },
  {
    label: "(UTC-09:00) Coordinated Universal Time-09",
    value: "Etc/GMT+9",
  },
  {
    label: "(UTC-08:00) Baja California",
    value: "America/Tijuana",
  },
  {
    label: "(UTC-08:00) Coordinated Universal Time-08",
    value: "Etc/GMT+8",
  },
  {
    label: "(UTC-08:00) Pacific Time (US & Canada)",
    value: "America/Los_Angeles",
  },
  {
    label: "(UTC-07:00) Arizona",
    value: "America/Phoenix",
  },
  {
    label: "(UTC-07:00) La Paz, Mazatlan",
    value: "America/Mazatlan",
  },
  {
    label: "(UTC-07:00) Mountain Time (US & Canada)",
    value: "America/Denver",
  },
  {
    label: "(UTC-06:00) Central America",
    value: "America/Guatemala",
  },
  {
    label: "(UTC-06:00) Central Time (US & Canada)",
    value: "America/Chicago",
  },
  {
    label: "(UTC-06:00) Mexico City",
    value: "America/Mexico_City",
  },
  {
    label: "(UTC-05:00) Eastern Time (US & Canada)",
    value: "America/New_York",
  },
  {
    label: "(UTC-05:00) Bogota, Lima",
    value: "America/Bogota",
  },
  {
    label: "(UTC-04:00) Atlantic Time (Canada)",
    value: "America/Halifax",
  },
  {
    label: "(UTC-04:00) Caracas",
    value: "America/Caracas",
  },
  {
    label: "(UTC-03:00) Buenos Aires",
    value: "America/Argentina/Buenos_Aires",
  },
  {
    label: "(UTC-03:00) Greenland",
    value: "America/Godthab",
  },
  {
    label: "(UTC-02:00) Coordinated Universal Time-02",
    value: "Etc/GMT+2",
  },
  {
    label: "(UTC-01:00) Azores",
    value: "Atlantic/Azores",
  },
  {
    label: "(UTC+00:00) Coordinated Universal Time",
    value: "UTC",
  },
  {
    label: "(UTC+00:00) London",
    value: "Europe/London",
  },
  {
    label: "(UTC+01:00) Central European Time",
    value: "Europe/Berlin",
  },
  {
    label: "(UTC+02:00) Eastern European Time",
    value: "Europe/Bucharest",
  },
  {
    label: "(UTC+03:00) Moscow",
    value: "Europe/Moscow",
  },
  {
    label: "(UTC+03:00) Riyadh",
    value: "Asia/Riyadh",
  },
  {
    label: "(UTC+04:00) Abu Dhabi, Muscat",
    value: "Asia/Dubai",
  },
  {
    label: "(UTC+05:00) Pakistan Standard Time",
    value: "Asia/Karachi",
  },
  {
    label: "(UTC+05:30) India Standard Time",
    value: "Asia/Kolkata",
  },
  {
    label: "(UTC+06:00) Bangladesh Standard Time",
    value: "Asia/Dhaka",
  },
  {
    label: "(UTC+07:00) Bangkok, Hanoi",
    value: "Asia/Bangkok",
  },
  {
    label: "(UTC+08:00) Beijing, Shanghai",
    value: "Asia/Shanghai",
  },
  {
    label: "(UTC+09:00) Tokyo",
    value: "Asia/Tokyo",
  },
  {
    label: "(UTC+10:00) Sydney",
    value: "Australia/Sydney",
  },
  {
    label: "(UTC+12:00) Auckland",
    value: "Pacific/Auckland",
  },
];